import { popoverMotion } from "../../../design-system/tokens/popoverMotion";
import styled, { css } from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { themedColor } from "../shared/themedColors";

export const Wrap = styled.div`
  position: relative;
`;

export const Trigger = styled.button<{ $open: boolean }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${spacing[2]};
  width: 100%;
  padding: ${spacing[2]} ${spacing[3]};
  background-color: ${themedColor.surface};
  border: 1px solid
    ${({ $open, theme }) => ($open ? rawColors.primary[500] : themedColor.stroke({ theme }))};
  border-radius: ${borderRadius.md};
  ${typographyMixin("body", 3)}
  color: ${themedColor.text};
  cursor: pointer;
  min-height: 42px;
  text-align: left;
`;

export const TriggerValue = styled.span<{ $placeholder: boolean }>`
  flex: 1;
  min-width: 0;
  ${({ $placeholder }) =>
    $placeholder &&
    css`
      color: ${themedColor.textTertiary};
    `}
`;

export const TriggerChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${spacing[2]};
  flex: 1;
  min-width: 0;
`;

/** Figma applied-filter value chip (node 6492:9126) — grey/300 fill, 6px radius, no border. */
export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1]};
  padding: ${spacing[0.5]} ${spacing[1.5]};
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};
  background-color: ${rawColors.grey[300]};
  border-radius: ${borderRadius.md};
`;

export const ChipRemove = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  color: ${rawColors.text.highEmphasis};
  cursor: pointer;
  padding: 0;

  &:hover {
    color: ${rawColors.text.mediumEmphasis};
  }
`;

export const Menu = styled.div`
  position: fixed;
  ${popoverMotion()}
  background-color: ${themedColor.surface};
  border: 1px solid ${themedColor.stroke};
  border-radius: ${borderRadius.md};
  box-shadow: 0 8px 24px rgba(89, 98, 112, 0.18);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  max-height: 280px;
  overflow: hidden;
`;

export const SearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  padding: ${spacing[2]} ${spacing[3]};
  border-bottom: 1px solid ${rawColors.stroke[100]};
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  ${typographyMixin("body", 3)}
  color: ${themedColor.text};

  &::placeholder {
    color: ${themedColor.textTertiary};
  }
`;

export const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: ${spacing[1]};
  overflow-y: auto;
`;

export const Item = styled.li`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  padding: ${spacing[2]} ${spacing[3]};
  border-radius: ${borderRadius.sm};
  ${typographyMixin("body", 3)}
  color: ${themedColor.text};
  cursor: pointer;

  &:hover {
    background-color: ${themedColor.hover};
  }
`;

export const EmptyState = styled.li`
  padding: ${spacing[3]};
  ${typographyMixin("caption", 3)}
  color: ${themedColor.textSecondary};
  text-align: center;
`;

export const Checkbox = styled.span<{ $checked: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 3px;
  border: 1.5px solid
    ${({ $checked }) => ($checked ? rawColors.primary[500] : rawColors.stroke[300])};
  background-color: ${({ $checked }) =>
    $checked ? rawColors.primary[500] : "transparent"};
  color: ${rawColors.text.white};
  flex-shrink: 0;

  &::after {
    content: ${({ $checked }) => ($checked ? '"✓"' : '""')};
    font-size: 11px;
    line-height: 1;
  }
`;
